module.exports = __webpack_public_path__ + "UX2.png?24a8e49f2c156bf1188f4e5459c70556";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX2.png
// module id = 69
// module chunks = 0